import { PageMeta } from '../components/seo/PageMeta'
import { pageMeta } from '../lib/seo'

export default function Privacy() {
  return (
    <>
      <PageMeta
        title={pageMeta.privacy.title}
        description={pageMeta.privacy.description}
        canonical={pageMeta.privacy.canonical}
      />
      <main className="min-h-screen pt-24 pb-16 px-6">
        <div className="max-w-3xl mx-auto">
          <p className="font-body text-cream-dim text-sm mb-8">Last updated: March 4, 2025.</p>
          <h1 className="font-display font-bold text-2xl uppercase text-white mb-8">
            Privacy Policy
          </h1>
          <div className="font-body text-cream-dim space-y-6 prose prose-invert max-w-none">
            <p>
              At NextTech Consultants, we are committed to protecting your privacy and ensuring the security of your personal data. This Privacy Policy explains how we collect, use, and protect the information we collect from our users.
            </p>

            <h2 className="font-display font-bold text-lg uppercase text-white mt-8 mb-2">What Data Are We Collecting?</h2>
            <p>We collect the following types of information:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong className="text-white">Personal Information:</strong> This includes data such as names, email addresses, phone numbers, and any other information you provide voluntarily.</li>
              <li><strong className="text-white">Usage Information:</strong> We collect data about how you interact with our website, including IP addresses, browser types, and device information.</li>
            </ul>

            <h2 className="font-display font-bold text-lg uppercase text-white mt-8 mb-2">Why Are We Collecting Data?</h2>
            <p>We collect data for the following purposes:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>To provide our services to you.</li>
              <li>To improve our website and enhance user experience.</li>
              <li>To communicate with you regarding our services, updates, and promotions.</li>
            </ul>

            <h2 className="font-display font-bold text-lg uppercase text-white mt-8 mb-2">Disclosure of Information</h2>
            <p>
              We do not sell or share your personal information with third parties for their direct marketing. Specifically, mobile phone numbers and SMS opt-in consent data are not shared, sold, rented, or transferred to third parties or affiliates for marketing or promotional purposes. We only share data with service providers as needed to deliver services (for example, SMS delivery platforms).
            </p>

            <h2 className="font-display font-bold text-lg uppercase text-white mt-8 mb-2">How Will We Use the Data?</h2>
            <p>We use the collected data for the following purposes:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>To provide and maintain our services.</li>
              <li>To communicate with you.</li>
              <li>To analyze website usage and improve our offerings.</li>
            </ul>
            <p>
              If you have opted in to receive SMS from us, you can opt out at any time by replying STOP to any message. Message and data rates may apply.
            </p>

            <h2 className="font-display font-bold text-lg uppercase text-white mt-8 mb-2">Retaining Your Information</h2>
            <p>
              We retain your information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy.
            </p>

            <h2 className="font-display font-bold text-lg uppercase text-white mt-8 mb-2">Compliance & Cooperation with Regulators</h2>
            <p>
              We comply with all applicable data protection laws and cooperate with regulatory authorities.
            </p>

            <h2 className="font-display font-bold text-lg uppercase text-white mt-8 mb-2">Contact Us</h2>
            <p>
              If you have any questions or concerns about our Privacy Policy, please contact us at{' '}
              <a href="mailto:info@nexttechconsultants.com" className="text-accent hover:underline">info@nexttechconsultants.com</a>.
            </p>
          </div>
        </div>
      </main>
    </>
  )
}
